// extracted by mini-css-extract-plugin
export var animated = "styles-module--animated--ce672";
export var image = "styles-module--image--0197d";